module.exports = __webpack_public_path__ + "img/footer-stars.bddf9810.png";